import { CheckCircleIcon, PencilSimpleIcon, TrashIcon, XCircleIcon } from '@phosphor-icons/react';

import type { ActionMenuGroup, ActionMenuItem } from '@/components/common/action-menu';

import type { DealerRow } from './types';

/** Each ticket wires the action it owns: 05 disable/enable, 08 edit, 06 delete. */
export type DealerRowHandlers = {
  onEdit?: (row: DealerRow) => void;
  onDisable?: (row: DealerRow) => void;
  onEnable?: (row: DealerRow) => void;
  onDelete?: (row: DealerRow) => void;
};

type DealerAction = DealerRow['actions'][number];

/** AC order (118479 §B): Edit, Disable | Enable, Delete — not Figma's (grilling Q4). */
const ORDER: DealerAction[] = ['edit', 'disable', 'enable', 'delete'];

const ITEMS: Record<DealerAction, Omit<ActionMenuItem, 'onClick'>> = {
  edit: { key: 'edit', label: 'Edit', icon: <PencilSimpleIcon /> },
  disable: { key: 'disable', label: 'Disable', icon: <XCircleIcon /> },
  enable: { key: 'enable', label: 'Enable', icon: <CheckCircleIcon /> },
  delete: { key: 'delete', label: 'Delete', icon: <TrashIcon />, danger: true },
};

/** The row's `actions[]` (BE, per status) as menu items. An item renders only when the row offers it
 *  AND its handler is wired, so Edit/Delete stay hidden until 08/06 land. All-empty groups make
 *  `<ActionMenu>` render nothing. */
export function dealerRowActionGroups(row: DealerRow, h: DealerRowHandlers): ActionMenuGroup[] {
  const handlers: Record<DealerAction, ((r: DealerRow) => void) | undefined> = {
    edit: h.onEdit,
    disable: h.onDisable,
    enable: h.onEnable,
    delete: h.onDelete,
  };
  const items: ActionMenuItem[] = [];
  for (const action of ORDER) {
    const handler = handlers[action];
    if (row.actions.includes(action) && handler) {
      items.push({ ...ITEMS[action], onClick: () => handler(row) });
    }
  }
  return [{ items }];
}
